import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'SettingsSection',
    mixins: [
        glSlotsMixin
    ],
    props: {
        heading: {
            type: String,
            required: false,
            default: ''
        },
        headingClasses: {
            type: String,
            required: false,
            default: null
        },
        description: {
            type: String,
            required: false,
            default: ''
        },
        noBottomBorder: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        hasHeading () {
            return this.glSlots().heading || this.heading;
        },
        hasDescription () {
            return this.glSlots().description || this.description;
        }
    }
};
